module.exports = require('./helpers/bundle-url').getBundleURL('4Im5F') + "logo.c51670a8.svg";